import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { TreeObservationService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TreeObservationCreateDto,
  TreeObservationDto,
  TreeObservationExcelDownloadDto,
  TreeObservationUpdateDto,
} from '../proxy/planning/dtos/tree-observation';
import { TREEOBSERVATION_CONFIG, TREEOBSERVATION_FIELDS } from './tree-observation.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-tree-observation',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TreeObservationService, ConfirmationService],
  templateUrl: './tree-observation.html',
  styleUrl: './tree-observation.scss',
})
export class TreeObservation extends BaseCrudComponent<
  TreeObservationDto,
  TreeObservationCreateDto,
  TreeObservationUpdateDto,
  TreeObservationExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(TreeObservationService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('TreeObservation', ids),
  };
  config = TREEOBSERVATION_CONFIG;
  fields = TREEOBSERVATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: TreeObservationDto): TreeObservationUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TreeObservation';
  }
}
